/* BCS free gift (Oct 2026): spend £40 on nutrients (collection hydroponic-nutrients-and-boosters) and a 250ml
   Rock Resinator is added to the basket automatically. The automatic discount "Free 250ml Rock Resinator when you
   spend £40 on nutrients" makes it free at checkout. If the spend drops below £40 the gift is removed. If the
   customer removes the gift themselves, it is not added back during that visit. The line carries a visible note.
   BCS-EMPTY-BASKET-GUARD (v21, 29 Oct 2026): the basket is read first, and the nutrient list (about 139KB) is only
   downloaded when the basket has something in it, instead of on every page view. */
(function () {
  'use strict';
  if (window.__bcsFreeGift) return;
  window.__bcsFreeGift = true;

  var GIFT_VARIANT = 55227823751495;   // Rock Resinator Bloom Additive, 250ml
  var THRESHOLD = 4000;                // £40.00 in pence
  var COLLECTION = 'hydroponic-nutrients-and-boosters';
  var FLAG = 'X-BCS-Gift';
  var busy = false, timer = null, idsPromise = null;

  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }

  function nutrientIds() {
    if (idsPromise) return idsPromise;
    var cached = store('bcsNutrientIds');
    if (cached) {
      try { var c = JSON.parse(cached); if (Date.now() - c.t < 3600000) { idsPromise = Promise.resolve(new Set(c.ids)); return idsPromise; } } catch (e) {}
    }
    idsPromise = fetch('/collections/' + COLLECTION + '/products.json?limit=250', { headers: { 'X-BCS-Gift': '1' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var ids = (j.products || []).map(function (p) { return p.id; });
        store('bcsNutrientIds', JSON.stringify({ t: Date.now(), ids: ids }));
        return new Set(ids);
      })
      .catch(function () { idsPromise = null; return new Set(); });
    return idsPromise;
  }

  function post(url, body) {
    var h = { 'Content-Type': 'application/json', 'Accept': 'application/json' }; h[FLAG] = '1';
    return fetch(url, { method: 'POST', headers: h, body: JSON.stringify(body) });
  }

  function isGift(item) { return item.variant_id === GIFT_VARIANT && item.properties && item.properties._bcs_gift; }

  function refresh() {
    if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
  }

  function check() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'X-BCS-Gift': '1' } }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var others = cart.items.filter(function (i) { return !isGift(i); });
        if (!others.length) {
          // Empty basket (or only the gift): no need for the nutrient list.
          var lone = cart.items.filter(isGift);
          if (lone.length) {
            return post('/cart/change.js', { id: lone[0].key, quantity: 0 }).then(function () { store('bcsGiftAdded', null); refresh(); });
          }
          store('bcsGiftAdded', null);
          store('bcsGiftDeclined', null);
          return;
        }
        return nutrientIds().then(function (ids) {
          if (!ids.size) return;
          var gifts = cart.items.filter(isGift);
          var spend = cart.items.reduce(function (s, i) { return (ids.has(i.product_id) && !isGift(i)) ? s + i.original_line_price : s; }, 0);
          var job = null;
          // Discount codes on this shop don't combine with the free-gift discount, so with a code applied the gift
          // would be charged. Don't add it (or take it out) while a code is on the basket.
          var hasCode = (cart.cart_level_discount_applications || []).some(function (d) { return d.type === 'discount_code'; }) ||
            cart.items.some(function (i) { return (i.line_level_discount_allocations || []).some(function (a) { return a.discount_application && a.discount_application.type === 'discount_code'; }); });
          if (hasCode && gifts.length) {
            job = post('/cart/change.js', { id: gifts[0].key, quantity: 0 }).then(function () { store('bcsGiftAdded', null); });
          } else if (spend >= THRESHOLD) {
            if (!gifts.length) {
              if (store('bcsGiftAdded')) { store('bcsGiftDeclined', '1'); store('bcsGiftAdded', null); }
              if (!store('bcsGiftDeclined') && !hasCode) {
                job = post('/cart/add.js', { items: [{ id: GIFT_VARIANT, quantity: 1, properties: { _bcs_gift: '1', 'Offer': 'FREE gift when you spend £40+ on nutrients' } }] })
                  .then(function (r) { if (r.ok) store('bcsGiftAdded', '1'); });
              }
            } else if (gifts[0].quantity !== 1 || gifts.length > 1) {
              job = post('/cart/change.js', { id: gifts[0].key, quantity: 1 });
            }
          } else if (gifts.length) {
            job = post('/cart/change.js', { id: gifts[0].key, quantity: 0 }).then(function () { store('bcsGiftAdded', null); });
          } else {
            store('bcsGiftAdded', null);
            store('bcsGiftDeclined', null);
          }
          if (job) return job.then(refresh);
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(check, 500); }
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/;

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var own = init && init.headers && (init.headers[FLAG] || (init.headers.get && init.headers.get(FLAG)));
    var p = origFetch.apply(this, arguments);
    if (!own && CART_RE.test(url)) p.then(schedule, schedule);
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_RE.test(String(url))) this.addEventListener('loadend', schedule);
    return origOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
